import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { withTranslation } from "../../translation";
import { showSortOverlay } from "../../../state/modules/layout/actions";
import styles from "./index.css";

export const SmallScreenSort = ({ formatTranslation }) => {
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <button
        id="sortBy"
        className={styles.button}
        onClick={() => dispatch(showSortOverlay())}
      >
        {formatTranslation("plp_web_sort_sort")}
      </button>
    </div>
  );
};

SmallScreenSort.displayName = "Sort";

SmallScreenSort.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(SmallScreenSort);
